import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

const Amenities = ({ id }) => {
  const [amenities, setAmenities] = useState([]);
  const [selectedAmenity, setSelectedAmenity] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      $(".amenitiesModel").click(function () {
        const amenitiesId = $(this).data("id");
        const amenity = amenities.find((v) => v.amenitiesID == amenitiesId);
        if (amenity) {
          setSelectedAmenity(amenity);
          setIsModalOpen(true);
        }
      });
    }, 1000);
  }, [amenities]);

  const fetchData = async () => {
    try {
      const response = await corefetch(
        `Amenities/GetAmenitiesDetailsByDisplayedInID?displayedInID=${id}`
      );
      if (response && response.length > 0) {
        const mappedAmenities = response.map((amenity) => ({
          ...amenity,
          image: `${ImageURL}${amenity.imagePath}`,
        }));
        setAmenities(mappedAmenities);
      } else {
        setAmenities([]);
        console.log("No amenities found");
      }
    } catch (error) {
      setAmenities([]);
      console.error("Error fetching amenities:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  useEffect(() => {
    if (amenities?.length) {
      if ($(".ameni-slider").length) {
        $(".ameni-slider").owlCarousel({
          autoplay: true,
          smartSpeed: 300,
          margin: 0.5,
          loop: true,
          autoplayHoverPause: true,
          dots: false,
          arrows: false,
          nav: false,
          center: true,
          items: 5,
          navText: [
            '<i class="ti-arrow-left"></i>',
            '<i class="ti-arrow-right"></i>',
          ],
          responsive: {
            0: {
              items: 1,
              dots: false,
              arrows: false,
              nav: false,
            },

            575: {
              items: 1,
            },
            767: {
              items: 1,
              dots: false,
            },

            992: {
              items: 5,
              dots: false,
            },

            1200: {
              items: 5,
            },
          },
        });
      }
    }
  }, [JSON.stringify(amenities)]);

  const openModal = (amenity) => {
    setSelectedAmenity(amenity);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedAmenity(null);
    setIsModalOpen(false);
  };

  if (!amenities || amenities.length === 0) {
    return null;
  }

  return (
    <>
      <section className="wpo-product-section section-padding p-0">
        <div className="container">
          <div className="wpo-section-title">
            <h4>Our Offer</h4>
            <h2>Amenities Meridian Offer</h2>
          </div>
          <div className="wpo-product-wrap">
            <div className="row ameni-slider owl-carousel">
              {amenities.map((amenity, index) => (
                <div
                  className="col-md-10 moreload amenitiesModel"
                  key={index}
                  data-id={amenity.amenitiesID}
                >
                  <div className="wpo-product-item">
                    {index % 2 === 0 ? (
                      <>
                        {/* Image first for even items */}
                        <div
                          className={`wpo-product-img ${
                            amenity.modelClass || ""
                          }`}
                          onClick={() => openModal(amenity)}
                          style={{ cursor: "pointer" }}
                        >
                          <img
                            src={amenity.image}
                            alt={amenity.amenitiesType}
                            style={{
                              width: "100%",
                              height: "300px",
                              objectFit: "cover",
                              borderRadius: "8px",
                            }}
                            className="even"
                          />
                        </div>
                        {/* Text */}
                        <div
                          className="wpo-product-text"
                          onClick={() => openModal(amenity)}
                          style={{
                            top: "-39px",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <h3 style={{ marginTop: "85px" }}>
                            <a>{amenity.amenitiesType}</a>
                          </h3>
                        </div>
                      </>
                    ) : (
                      <>
                        {/* Text first for odd items */}

                        <div
                          className="wpo-product-text "
                          onClick={() => openModal(amenity)}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <div
                            style={{
                              position: "absolute",
                              // left: "50%",
                              bottom: "71px",
                              // transform: "translateX(-50%)",s
                              zIndex: "1000",
                            }}
                          >
                            <h3>
                              <a>{amenity.amenitiesType}</a>
                            </h3>
                          </div>
                        </div>
                        {/* Image */}
                        <div
                          className={`wpo-product-img ${
                            amenity.modelClass || ""
                          }`}
                          onClick={() => openModal(amenity)}
                          style={{ cursor: "pointer" }}
                        >
                          <img
                            src={amenity.image}
                            alt={amenity.amenitiesType}
                            style={{
                              width: "100%",
                              height: "300px",
                              objectFit: "cover",
                              borderRadius: "8px",
                            }}
                            className="odd"
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Modal Popup */}
      {isModalOpen && selectedAmenity && (
        <div className="popup">
          <div
            className="modal-content amenities"
            style={{
              maxHeight: "90vh",
              overflowY: "auto",
              padding: "20px",
              borderRadius: "8px",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            <span className="close" onClick={closeModal}>
              &times;
            </span>
            <div className="modal-header">{selectedAmenity.amenitiesType}</div>
            <div className="additional-text">
              <div className="row">
                <div className="col-5">
                  <img
                    src={selectedAmenity.image}
                    alt={selectedAmenity.amenitiesType}
                    style={{
                      width: "100%",
                      height: "auto",
                      objectFit: "cover",
                      borderRadius: "8px",
                      maxWidth: "100%",
                    }}
                    className="odd"
                  />
                </div>
                <div className="col-7">
                  <p>{selectedAmenity.description}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Amenities;
